import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { setMapUi } from '../store/ui';
import MapIcon from '../lib/img/map.png';
import { setPanoramaId } from '../store/panorama';

const MapViewButtonElement = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;

  font-family: 'Source Code Pro', monospace;
  font-size: 1rem;
  line-height: 1.25;
  padding: 0.25em 0.5em 0.3em;
  background-color: transparent;
  text-align: center;
  color: white;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-sizing: border-box;
  text-shadow: 0 0 0.4em black;
  text-transform: uppercase;
  letter-spacing: 0.0375em;
  box-shadow: 0 0 0.6em rgba(0,0,0,0.2), inset 0 0 0.6em rgba(0,0,0,0.2);
  width: auto;

  &:not([disabled]):hover {
    background-color: rgba(0,0,0,0.6);
  }

  &[disabled] {
    cursor: default;
    opacity: 0.4;
  }
`;

const MapViewButton = ({
  isMapUi,
  toMapUi,
}) => {
  if (isMapUi) {
    return null;
  }

  return (
    <MapViewButtonElement
      id="to-map-view-button"
      aria-label="Navigate back to map"
      icon={MapIcon}
      onClick={toMapUi}
    >
      Map
    </MapViewButtonElement>
  );
};

MapViewButton.propTypes = {
  isMapUi: PropTypes.bool.isRequired,
  toMapUi: PropTypes.func.isRequired,
};

export default connect(
    ({ ui }) => ({
      isMapUi: ui.isMapUi,
    }),

    (dispatch) => ({
      toMapUi: () => {
        dispatch(setPanoramaId('', false));
        dispatch(setMapUi(true));
      },
    }),
)(MapViewButton);
